import {LocalDataLoader} from "./LocalDataLoader";
import {FileFeatureReaderFn, FileType, FormatMap} from "../data/FileType";
import {MediaType, MediaTypes} from "../data/MediaTypes";
import {GPX, KML} from "ol/format";
import {KMZ} from "../data/KMZ";

export const foregroundTypes: MediaType[] = [
    MediaTypes.KML, MediaTypes.KMZ, MediaTypes.GPX
];

const featureFormats: FormatMap = new Map<FileType, FileFeatureReaderFn>(
    [
        [
            {
                extension: 'kml',
                mediaType: MediaTypes.KML,
                encoding: 'text'
            },
            () => new KML({ crossOrigin: "Anonymous" })
        ],
        [
            {
                extension: 'kmz',
                mediaType: MediaTypes.KMZ,
                encoding: 'File'
            },
            () => new KMZ()
        ],
        [
            {
                extension: 'gpx',
                mediaType: MediaTypes.GPX,
                encoding: 'text'
            },
            () => new GPX()
        ]
    ]
);

export class ForegroundDataLoader extends LocalDataLoader {
    constructor() {
        super(featureFormats);
    }
}